import { TRAN_DOI_NGU } from "../lib/validateWorkspace.js";

/**
 * Danh sách người sáng lập trong Hồ sơ startup.
 *
 * Vì sao đây là mục đáng thêm nhất: ở vòng angel và pre-seed, nhà đầu tư đặt
 * cược vào người chứ không vào sản phẩm. Câu "vì sao là các bạn làm việc này"
 * gần như luôn được hỏi, và hai thứ trả lời được nó là AI TOÀN THỜI GIAN và AI
 * AM HIỂU NGÀNH. Vì thế hai ô đó nằm ngay trên dòng, không giấu trong phần mở
 * rộng — số người thì không nói lên điều gì.
 *
 * Không có ô lương, cổ phần hay thông tin cá nhân: bản một trang là tài liệu
 * gửi ra ngoài, và những thứ đó không thuộc về nó.
 */
export default function DoiNgu({ danhSach, onChange, disabled }) {
  const ds = Array.isArray(danhSach) ? danhSach : [];

  const sua = (i, patch) =>
    onChange(ds.map((n, j) => (j === i ? { ...n, ...patch } : n)));

  return (
    <section className="surface section-space">
      <div className="section-bar">
        <h2>Đội ngũ sáng lập</h2>
        <span className="pill">
          {ds.length}/{TRAN_DOI_NGU}
        </span>
      </div>
      <p className="muted">
        Ở vòng đầu, đây thường là mục nhà đầu tư đọc kỹ nhất. Ghi đúng thực tế:
        một người toàn thời gian nói được nhiều hơn năm người bán thời gian.
      </p>

      {ds.map((n, i) => (
        <div className="doi-ngu-hang" key={i}>
          <div className="o-nhap">
            <div>
              <label htmlFor={`dn-ten-${i}`}>Họ tên</label>
              <input
                id={`dn-ten-${i}`}
                type="text"
                maxLength={80}
                value={n.ten || ""}
                onChange={(e) => sua(i, { ten: e.target.value })}
              />
            </div>
            <div>
              <label htmlFor={`dn-vaitro-${i}`}>Vai trò</label>
              <input
                id={`dn-vaitro-${i}`}
                type="text"
                maxLength={60}
                placeholder="CEO"
                value={n.vaiTro || ""}
                onChange={(e) => sua(i, { vaiTro: e.target.value })}
              />
            </div>
            <div>
              <label htmlFor={`dn-nam-${i}`}>Số năm trong ngành</label>
              <input
                id={`dn-nam-${i}`}
                type="number"
                min="0"
                max="60"
                value={n.namNganh || ""}
                onChange={(e) => sua(i, { namNganh: e.target.value })}
              />
            </div>
          </div>
          <div className="doi-ngu-cuoi">
            <label className="task-row">
              <input
                type="checkbox"
                checked={!!n.toanThoiGian}
                onChange={(e) => sua(i, { toanThoiGian: e.target.checked })}
              />
              <span>Làm toàn thời gian</span>
            </label>
            <button
              className="nut phu"
              onClick={() => onChange(ds.filter((_, j) => j !== i))}
            >
              Bỏ người này
            </button>
          </div>
        </div>
      ))}

      {!ds.length && (
        <p className="muted">Chưa có ai. Thêm ít nhất người sáng lập chính.</p>
      )}

      <div className="hang-nut">
        <button
          className="nut phu"
          disabled={disabled || ds.length >= TRAN_DOI_NGU}
          onClick={() =>
            onChange([...ds, { ten: "", vaiTro: "", namNganh: "", toanThoiGian: false }])
          }
        >
          Thêm người sáng lập
        </button>
      </div>
      {ds.length >= TRAN_DOI_NGU && (
        <p className="nho muted">
          Bản một trang chỉ nên liệt kê người sáng lập, không phải toàn bộ nhân
          sự. Quy mô đội ngũ đã có ô riêng trong hồ sơ.
        </p>
      )}
    </section>
  );
}
